import React, { useState } from "react";
import "react-dropzone-uploader/dist/styles.css";
import Dropzone from "react-dropzone-uploader";
import { getDroppedOrSelectedFiles } from "html5-file-selector";

const FileUploadComponent = ({fineInfo,setFileInfo,type,disabled,path}) => {
  const fileParams = ({ file, meta }) => {
    return {
      url: "https://httpbin.org/post",
      
      // "https://httpbin.org/post"
    };
  };
  const onFileChange = ({ meta, file }, status) => {
    setFileInfo({ status, meta, file });
    // props.setValidationErrors({ passport:""});
  };

  return (
    <>
      <Dropzone
        disabled={disabled}
        //   onSubmit={onSubmit}
        onChangeStatus={onFileChange}
        // InputComponent={selectFileInput}
        // getUploadParams={fileParams}
        //   getFilesFromEvent={getFilesFromEvent}
        accept={
          type=="Passport" ? "image/*" :
          type=="voters" ? "image/*" :
          type=="intrenationalPassport" ? "image/*" :
          "image/png, image/jpg, image/jpeg,.pdf"}
        maxFiles={1}
        multiple={false}
        maxSizeBytes={1024 * 1024 * 5}
        submitButtonContent={null}
        SubmitButtonComponent={null}
        inputWithFilesContent={null}
        inputContent={disabled ? path:"Drag "+type+" or Click to Select "+type+"(<5MB)"}
        // width: 500,        
        styles={{
          dropzone: { 
            height: 40, 
            minHeight:55, 
            width: 'auto', 
            overflow: "hidden",
            fontFamily:"Garamond",
            fontWeight:"none",
          },
          dropzoneActive: { 
            color: "red",
            fontSize: "2px"
         },
         inputLabel: {
          fontSize: "5px",
          opacity: "20%",
         },
         previewImage: {
          margin: "51px 0px 24px -4px"
         },
         previewButton: {
          margin: "20px 0px 2px 10px",
        },
        }}
      />
      {fineInfo?.status == "done" ? fineInfo?.meta?.name : ""}
    </>
  );
};
export default FileUploadComponent;
